import React from "react";
import ReactDOM from "react-dom/client";
import { hydrate, render } from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./ErrorBoundery/ErrorBoundary";
// Add this in index.js or App.js
import "leaflet/dist/leaflet.css";

const AppComponent = (
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  hydrate(AppComponent, rootElement);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(AppComponent);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
